import React, { Fragment } from 'react';
import Box from 'components/elements/Box';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';
import times from 'lodash.times';
import styled from 'styled-components/macro';

const Loader = styled(ContentLoader)`
  width: 100%;
`;

const JobLoader: React.FC = () => {
  const count = 5;

  return (
    <Box my={2} padding="0 2.5rem">
      <AnimatedLoadingWrapper loading={true}>
        <Loader
          width={570}
          height={90 + (count - 1) * 55}
          uniquekey="JobSkeleton"
        >
          {times(count, (idx) => (
            <Fragment key={`event-skeleton-${idx}`}>
              <rect width="570" height="50" y={20 + 55 * idx} />
            </Fragment>
          ))}
        </Loader>
      </AnimatedLoadingWrapper>
    </Box>
  );
};

export default JobLoader;
